<template>
  <div>
    <div id="content" class="yatis-content">
      <div class="wizard">
        <div class="wizard-bar">
          <div class="page">
            <div class="no">
              {{ activeTab }} / {{ Object.keys(tabs).length }}
            </div>
            <div class="head">{{ head }}</div>
          </div>
        </div>
        <div class="wizard-content">
          <form class="p-form" autocomplete="off" v-on:submit.prevent>
            <div v-show="activeTab == 1">
              <p>
                > Hastanemizde doğan bir bebeğin yatışını yapmak için
                <router-link to="/birthlist" class="c-blue bold">
                  tıklayın
                </router-link>
              </p>
              <br />
              <div class="labeledit">
                <label for="p-adi">Adı Soyadı*</label>
                <input type="text" v-model="yatis.name" id="p-adi" required />
              </div>
              <div class="labeledit">
                <label for="p-dogum">
                  Doğum Tarihi ve Saati*
                </label>
                <input
                  type="datetime-local"
                  v-model="yatis.birth"
                  id="p-dogum"
                  required
                />
              </div>
              <div class="labeledit">
                <label>Cinsiyet*</label>

                <div class="toggle-group">
                  <label for="p-cinsiyet-1">
                    <input
                      id="p-cinsiyet-1"
                      class="modern"
                      type="radio"
                      value="1"
                      name="cinsiyet"
                      v-model="yatis.sex"
                      required
                    />
                    <span>Erkek</span>
                  </label>

                  <label for="p-cinsiyet-2">
                    <input
                      id="p-cinsiyet-2"
                      class="modern"
                      type="radio"
                      value="2"
                      name="cinsiyet"
                      v-model="yatis.sex"
                      required
                    />
                    <span>Kız</span>
                  </label>
                </div>
              </div>
              <br />
              <h4>Doğum Özellikleri</h4>
              <div class="labeledit">
                <label for="p-week">Gestasyonel Hafta*</label>
                <div class="multi-input">
                  <input
                    type="number"
                    placeholder="34 haftalıksa 34 yazın"
                    id="p-week"
                    v-model="yatis.dhafta"
                    required
                  />
                  <div class="space"></div>
                  <input
                    type="number"
                    placeholder="0-6 arası gün yazın"
                    id="p-day"
                    v-model="yatis.dgun"
                  />
                </div>
              </div>

              <div class="labeledit">
                <label for="p-kilo">Tartı (gr)*</label>
                <div class="multi-input">
                  <input
                    type="number"
                    v-model.number="yatis.dtarti"
                    id="p-kilo"
                    placeholder="Doğum Tartısı"
                    required
                  />
                  <div class="space"></div>
                  <input
                    type="number"
                    v-model.number="yatis.ytarti"
                    id="p-ykilo"
                    required
                    placeholder="Yatış Tartısı"
                  />
                </div>
              </div>
              <div class="labeledit">
                <label for="p-boy">Boy ve Baş Çevresi</label>
                <div class="multi-input">
                  <input
                    type="number"
                    v-model.number="yatis.boy"
                    id="p-boy"
                    placeholder="Boy (cm)"
                  />
                  <div class="space"></div>
                  <input
                    type="number"
                    v-model.number="yatis.basc"
                    id="p-basc"
                    placeholder="Baş Çevresi (cm)"
                  />
                </div>
              </div>
              <div class="labeledit">
                <label for="p-sekil">
                  Doğum Şekli ve Apgar
                </label>
                <div class="multi-input">
                  <select id="p-sekil" v-model="yatis.sekil">
                    <option value>(Belli Değil)</option>
                    <option value="SPİNAL ANESTEZİ ALTINDA C/S">
                      Spinal Anestezi - C/S
                    </option>
                    <option value="GENEL ANESTEZİ ALTINDA C/S">
                      Genel Anestezi - C/S
                    </option>
                    <option value="NVD">NVD</option>
                  </select>
                  <div class="space"></div>
                  <input
                    type="text"
                    id="p-apgar"
                    placeholder="APGAR skoru"
                    v-model="yatis.apgar"
                  />
                </div>
              </div>
              <div class="labeledit">
                <label>Hepatit B Aşısı</label>

                <div class="toggle-group">
                  <label for="p-hepb-1">
                    <input
                      id="p-hepb-1"
                      class="modern"
                      type="radio"
                      value="1"
                      name="hepb"
                      v-model="yatis.hepb"
                    />
                    <span>Bilinmiyor</span>
                  </label>

                  <label for="p-hepb-2">
                    <input
                      id="p-hepb-2"
                      class="modern"
                      type="radio"
                      value="2"
                      name="hepb"
                      v-model="yatis.hepb"
                    />
                    <span>Yapıldı</span>
                  </label>

                  <label for="p-hepb-3">
                    <input
                      id="p-hepb-3"
                      class="modern"
                      type="radio"
                      value="3"
                      name="hepb"
                      v-model="yatis.hepb"
                    />
                    <span>Yapılmadı</span>
                  </label>
                </div>
              </div>
              <div class="labeledit">
                <label>K Vit.</label>

                <div class="toggle-group">
                  <label for="p-kvit-1">
                    <input
                      id="p-kvit-1"
                      class="modern"
                      type="radio"
                      value="1"
                      name="kvit"
                      v-model="yatis.kvit"
                    />
                    <span>Bilinmiyor</span>
                  </label>

                  <label for="p-kvit-2">
                    <input
                      id="p-kvit-2"
                      class="modern"
                      type="radio"
                      value="2"
                      name="kvit"
                      v-model="yatis.kvit"
                    />
                    <span>Yapıldı</span>
                  </label>

                  <label for="p-kvit-3">
                    <input
                      id="p-kvit-3"
                      class="modern"
                      type="radio"
                      value="3"
                      name="kvit"
                      v-model="yatis.kvit"
                    />
                    <span>Yapılmadı</span>
                  </label>
                </div>
              </div>
              <br />
              <div class="labeledit">
                <label>Başvuru ve Resusitasyon</label>
                <div class="toggle-group vertical">
                  <label for="res1">
                    <input
                      id="res1"
                      class="modern"
                      type="radio"
                      value="1"
                      v-model="yatis.res"
                    />
                    <span>Anne Yanından Yatış</span>
                  </label>

                  <label for="res2">
                    <input
                      id="res2"
                      class="modern"
                      type="radio"
                      value="2"
                      v-model="yatis.res"
                    />
                    <span>Poliklinik/Acil Yatış</span>
                  </label>

                  <label for="res3">
                    <input
                      id="res3"
                      class="modern"
                      type="radio"
                      value="3"
                      v-model="yatis.res"
                    />
                    <span>Dış Merkezden Sevk</span>
                  </label>

                  <label for="res4">
                    <input
                      id="res4"
                      class="modern"
                      type="radio"
                      value="4"
                      v-model="yatis.res"
                    />
                    <span>PBV Uygulanmadı</span>
                  </label>

                  <label for="res5">
                    <input
                      id="res5"
                      class="modern"
                      type="radio"
                      value="5"
                      v-model="yatis.res"
                    />
                    <span>Sadece PBV Uygulandı</span>
                  </label>

                  <label for="res6">
                    <input
                      id="res6"
                      class="modern"
                      type="radio"
                      value="6"
                      v-model="yatis.res"
                    />
                    <span>Entübe Edildi</span>
                  </label>
                </div>
              </div>
              <br />
              <div class="labeledit">
                <label for="p-dr">Yatıran Doktor</label>
                <select id="p-dr" v-model="yatirandr">
                  <option :value="{ id: 0 }">(Yok)</option>
                  <option
                    :value="{ id: d.id, name: d.name }"
                    v-for="d in activedoctors"
                    :key="d.id"
                  >
                    Dr.{{ d.name }}
                  </option>
                </select>
              </div>
              <br />
            </div>
            <div v-show="activeTab == 2">
              <div class="labeledit">
                <label for="p-anneyas">Anne Yaşı</label>
                <input
                  type="number"
                  v-model.number="yatis.anneyas"
                  id="p-anneyas"
                />
              </div>
              <div class="labeledit">
                <label for="p-gebelik">
                  Gebelik ve Yaşayan
                </label>
                <div class="multi-input">
                  <input
                    type="number"
                    placeholder="Gebelik Sayısı"
                    id="p-gebelik"
                    v-model="yatis.gebelik"
                  />
                  <div class="space"></div>
                  <input
                    type="number"
                    placeholder="Yaşayan Sayısı"
                    id="p-yasayan"
                    v-model="yatis.yasayan"
                  />
                </div>
              </div>
              <br />
              <h4>Anne ELISA ve Özgeçmiş</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="elisa1">
                    <input
                      id="elisa1"
                      class="modern"
                      type="radio"
                      value=""
                      v-model="yatis.elisa"
                    />
                    <span>Bilinmiyor</span>
                  </label>

                  <label for="elisa2">
                    <input
                      id="elisa2"
                      class="modern"
                      type="radio"
                      value="ELISA (-)"
                      v-model="yatis.elisa"
                    />
                    <span>ELISA (-)</span>
                  </label>

                  <label for="elisa3">
                    <input
                      id="elisa3"
                      class="modern"
                      type="radio"
                      value="Hepatit B (+)"
                      v-model="yatis.elisa"
                    />
                    <span>Hepatit B (+)</span>
                  </label>

                  <label for="elisa4">
                    <input
                      id="elisa4"
                      class="modern"
                      type="radio"
                      value="Hepatit C (+)"
                      v-model="yatis.elisa"
                    />
                    <span>Hepatit C (+)</span>
                  </label>

                  <label for="elisa5">
                    <input
                      id="elisa5"
                      class="modern"
                      type="radio"
                      value="HIV (+)"
                      v-model="yatis.elisa"
                    />
                    <span>HIV (+)</span>
                  </label>

                  <label for="elisa6">
                    <input
                      id="elisa6"
                      class="modern"
                      type="radio"
                      value="COVID-19 (+)"
                      v-model="yatis.elisa"
                    />
                    <span>COVID-19 (+)</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="anne1">
                    <input
                      id="anne1"
                      class="modern"
                      type="checkbox"
                      value="PREEKLAMPSİ (+)"
                      v-model="yatis.anneoyku"
                    />
                    <span>Preeklampsi (+)</span>
                  </label>

                  <label for="anne2">
                    <input
                      id="anne2"
                      class="modern"
                      type="checkbox"
                      value="DİYABET (+)"
                      v-model="yatis.anneoyku"
                    />
                    <span>Diyabet (+)</span>
                  </label>

                  <label for="anne3">
                    <input
                      id="anne3"
                      class="modern"
                      type="checkbox"
                      value="EMR (+)"
                      v-model="yatis.anneoyku"
                    />
                    <span>EMR (+)</span>
                  </label>

                  <label for="anne4">
                    <input
                      id="anne4"
                      class="modern"
                      type="checkbox"
                      value="ENFEKSİYON (+)"
                      v-model="yatis.anneoyku"
                    />
                    <span>Enfeksiyon (+)</span>
                  </label>

                  <label for="anne5">
                    <input
                      id="anne5"
                      class="modern"
                      type="checkbox"
                      value="PLASENTA PREVIA (+)"
                      v-model="yatis.anneoyku"
                    />
                    <span>Plasenta Previa (+)</span>
                  </label>

                  <label for="anne6">
                    <input
                      id="anne6"
                      class="modern"
                      type="checkbox"
                      value="İLAÇ KULLANIMI (+)"
                      v-model="yatis.anneoyku"
                    />
                    <span>İlaç Kullanımı (+)</span>
                  </label>
                </div>
              </div>
              <br />
              <div class="labeledit">
                <label>Antepartum Kanama</label>

                <div class="toggle-group">
                  <label for="p-kanama1">
                    <input
                      id="p-kanama1"
                      class="modern"
                      type="radio"
                      value="?"
                      v-model="yatis.kanama"
                    />
                    <span>Bilinmiyor</span>
                  </label>

                  <label for="p-kanama2">
                    <input
                      id="p-kanama2"
                      class="modern"
                      type="radio"
                      value="YOK"
                      v-model="yatis.kanama"
                    />
                    <span>Hayır</span>
                  </label>

                  <label for="p-kanama3">
                    <input
                      id="p-kanama3"
                      class="modern"
                      type="radio"
                      value="VAR"
                      v-model="yatis.kanama"
                    />
                    <span>Evet</span>
                  </label>
                </div>
              </div>
              <div class="labeledit">
                <label for="p-steroid">Antenatal Steroid</label>
                <select id="p-steroid" v-model="yatis.steroid">
                  <option value>(Bilinmiyor)</option>
                  <option value="CELESTONE YAPILMAMIŞ">
                    (-)
                  </option>
                  <option value="TEK DOZ CELESTONE YAPILMIŞ">
                    Tek Doz Celestone
                  </option>
                  <option value="2 DOZ CELESTONE YAPILMIŞ">
                    2 Doz Celestone
                  </option>
                </select>
              </div>
              <br />
              <h4>Kan Grupları</h4>

              <div class="labeledit">
                <label for="p-mommykan">Anne Kan Grubu</label>
                <select id="p-mommykan" v-model="yatis.annekan">
                  <option value>(Belli Değil)</option>
                  <option value="0 Rh(+)">0 Rh(+)</option>
                  <option value="A Rh(+)">A Rh(+)</option>
                  <option value="B Rh(+)">B Rh(+)</option>
                  <option value="AB Rh(+)">AB Rh(+)</option>
                  <option value="0 Rh(-)">0 Rh(-)</option>
                  <option value="A Rh(-)">A Rh(-)</option>
                  <option value="B Rh(-)">B Rh(-)</option>
                  <option value="AB Rh(-)">AB Rh(-)</option>
                </select>
              </div>
              <div class="labeledit">
                <label for="p-babykan">Bebek Kan Grubu</label>
                <select id="p-babykan" v-model="yatis.kan">
                  <option value>(Belli Değil)</option>
                  <option value="0 Rh (+)">0 Rh (+)</option>
                  <option value="A Rh (+)">A Rh (+)</option>
                  <option value="B Rh (+)">B Rh (+)</option>
                  <option value="AB Rh (+)">AB Rh (+)</option>
                  <option value="0 Rh (-)">0 Rh (-)</option>
                  <option value="A Rh (-)">A Rh (-)</option>
                  <option value="B Rh (-)">B Rh (-)</option>
                  <option value="AB Rh (-)">AB Rh (-)</option>
                </select>
              </div>
              <div class="labeledit">
                <label for="p-babycoombs">Bebek D.Coombs</label>
                <select id="p-babycoombs" v-model="yatis.coombs">
                  <option value>(Belli Değil)</option>
                  <option value="D.Coombs (-)">
                    D.Coombs (-)
                  </option>
                  <option value="D.Coombs (-+)">
                    D.Coombs (-+)
                  </option>
                  <option value="D.Coombs (+)">
                    D.Coombs (+)
                  </option>
                  <option value="D.Coombs (++)">
                    D.Coombs (++)
                  </option>
                  <option value="D.Coombs (+++)">
                    D.Coombs (+++)
                  </option>
                  <option value="D.Coombs (++++)">
                    D.Coombs (++++)
                  </option>
                </select>
              </div>
            </div>
            <div v-show="activeTab == 3">
              <h4>Ana Tanılar</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="tani1">
                    <input
                      id="tani1"
                      class="modern"
                      type="checkbox"
                      :value="'PREMATÜRİTE (' + gh + ')'"
                      v-model="yatis.tanilar"
                    />
                    <span>Prematürite ({{ gh }})</span>
                  </label>

                  <label for="tani2">
                    <input
                      id="tani2"
                      class="modern"
                      type="checkbox"
                      value="DDA"
                      v-model="yatis.tanilar"
                    />
                    <span>DDA</span>
                  </label>
                  <label for="tani3">
                    <input
                      id="tani3"
                      class="modern"
                      type="checkbox"
                      value="ADDA"
                      v-model="yatis.tanilar"
                    />
                    <span>ADDA</span>
                  </label>

                  <label for="tani4">
                    <input
                      id="tani4"
                      class="modern"
                      type="checkbox"
                      value="ERKEN NEONATAL SEPSİS"
                      v-model="yatis.tanilar"
                    />
                    <span>Erken Neonatal Sepsis</span>
                  </label>

                  <label for="tani5">
                    <input
                      id="tani5"
                      class="modern"
                      type="checkbox"
                      value="GEÇ NEONATAL SEPSİS"
                      v-model="yatis.tanilar"
                    />
                    <span>Geç Neonatal Sepsis</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="tani6">
                    <input
                      id="tani6"
                      class="modern"
                      type="checkbox"
                      value="YD EKSİK BESLENMESİ"
                      v-model="yatis.tanilar"
                    />
                    <span>YD Eksik Beslenmesi</span>
                  </label>
                  <label for="tani7">
                    <input
                      id="tani7"
                      class="modern"
                      type="checkbox"
                      value="ABO UYGUNSUZLUĞU"
                      v-model="yatis.tanilar"
                    />
                    <span>ABO Uygunsuzluğu</span>
                  </label>

                  <label for="tani8">
                    <input
                      id="tani8"
                      class="modern"
                      type="checkbox"
                      value="RH UYGUNSUZLUĞU"
                      v-model="yatis.tanilar"
                    />
                    <span>RH Uygunsuzluğu</span>
                  </label>
                  <label for="tani9">
                    <input
                      id="tani9"
                      class="modern"
                      type="checkbox"
                      value="COVID-19 (+) ANNE BEBEĞİ"
                      v-model="yatis.tanilar"
                    />
                    <span>COVID-19 Anne Bebeği</span>
                  </label>

                  <label for="tani10">
                    <input
                      id="tani10"
                      class="modern"
                      type="checkbox"
                      value="DİYABETİK ANNE BEBEĞİ"
                      v-model="yatis.tanilar"
                    />
                    <span>Diyabetik Anne Bebeği</span>
                  </label>
                </div>
              </div>
              <h4>Cilt & Baş ve Boyun</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="tani11">
                    <input
                      id="tani11"
                      class="modern"
                      type="checkbox"
                      value="YD SARILIĞI"
                      v-model="yatis.tanilar"
                    />
                    <span>YD Sarılığı</span>
                  </label>
                  <label for="tani12">
                    <input
                      id="tani12"
                      class="modern"
                      type="checkbox"
                      value="DEHİDRATASYON"
                      v-model="yatis.tanilar"
                    />
                    <span>Dehidratasyon</span>
                  </label>
                  <label for="tani13">
                    <input
                      id="tani13"
                      class="modern"
                      type="checkbox"
                      value="KOANAL ATREZİ"
                      v-model="yatis.tanilar"
                    />
                    <span>Koanal Atrezi</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="tani14">
                    <input
                      id="tani14"
                      class="modern"
                      type="checkbox"
                      value="YARIK DAMAK"
                      v-model="yatis.tanilar"
                    />
                    <span>Yarık Damak</span>
                  </label>
                  <label for="tani15">
                    <input
                      id="tani15"
                      class="modern"
                      type="checkbox"
                      value="YARIK DUDAK"
                      v-model="yatis.tanilar"
                    />
                    <span>Yarık Dudak</span>
                  </label>

                  <label for="tani16">
                    <input
                      id="tani16"
                      class="modern"
                      type="checkbox"
                      value="ÖZEFAGUS ATREZİSİ"
                      v-model="yatis.tanilar"
                    />
                    <span>Özefagus Atrezisi</span>
                  </label>
                </div>
              </div>
              <h4>Solunum & KVS</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="tani17">
                    <input
                      id="tani17"
                      class="modern"
                      type="checkbox"
                      value="TTN"
                      v-model="yatis.tanilar"
                    />
                    <span>TTN</span>
                  </label>

                  <label for="tani18">
                    <input
                      id="tani18"
                      class="modern"
                      type="checkbox"
                      value="KONJENİTAL PNÖMONİ"
                      v-model="yatis.tanilar"
                    />
                    <span>Konjenital Pnömoni</span>
                  </label>

                  <label for="tani19">
                    <input
                      id="tani19"
                      class="modern"
                      type="checkbox"
                      value="RDS"
                      v-model="yatis.tanilar"
                    />
                    <span>RDS</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="tani20">
                    <input
                      id="tani20"
                      class="modern"
                      type="checkbox"
                      value="DİYAFRAGMA HERNİSİ"
                      v-model="yatis.tanilar"
                    />
                    <span>Diyafragma Hernisi</span>
                  </label>
                  <label for="tani21">
                    <input
                      id="tani21"
                      class="modern"
                      type="checkbox"
                      value="KONJENİTAL KALP HASTALIĞI"
                      v-model="yatis.tanilar"
                    />
                    <span>Konjenital Kalp Hastalığı</span>
                  </label>

                  <label for="tani22">
                    <input
                      id="tani22"
                      class="modern"
                      type="checkbox"
                      value="PULMONER HİPERTANSİYON"
                      v-model="yatis.tanilar"
                    />
                    <span>Pulmoner Hipertansiyon</span>
                  </label>
                </div>
              </div>
              <h4>Batın & Genitoüriner</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="tani23">
                    <input
                      id="tani23"
                      class="modern"
                      type="checkbox"
                      value="OMFALOSEL"
                      v-model="yatis.tanilar"
                    />
                    <span>Omfalosel</span>
                  </label>
                  <label for="tani24">
                    <input
                      id="tani24"
                      class="modern"
                      type="checkbox"
                      value="GASTROŞİZİS"
                      v-model="yatis.tanilar"
                    />
                    <span>Gastroşizis</span>
                  </label>
                  <label for="tani25">
                    <input
                      id="tani25"
                      class="modern"
                      type="checkbox"
                      value="İLEUS"
                      v-model="yatis.tanilar"
                    />
                    <span>İleus</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="tani26">
                    <input
                      id="tani26"
                      class="modern"
                      type="checkbox"
                      value="İNTRAABDOMİNAL KİTLE"
                      v-model="yatis.tanilar"
                    />
                    <span>İntraabdominal Kitle</span>
                  </label>

                  <label for="tani27">
                    <input
                      id="tani27"
                      class="modern"
                      type="checkbox"
                      value="İNMEMİŞ TESTİS"
                      v-model="yatis.tanilar"
                    />
                    <span>İnmemiş Testis</span>
                  </label>
                  <label for="tani28">
                    <input
                      id="tani28"
                      class="modern"
                      type="checkbox"
                      value="ANAL ATREZİ"
                      v-model="yatis.tanilar"
                    />
                    <span>Anal Atrezi</span>
                  </label>
                </div>
              </div>
              <h4>Nörolojik</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="tani29">
                    <input
                      id="tani29"
                      class="modern"
                      type="checkbox"
                      value="MENİNGOSEL"
                      v-model="yatis.tanilar"
                    />
                    <span>Meningosel</span>
                  </label>
                  <label for="tani30">
                    <input
                      id="tani30"
                      class="modern"
                      type="checkbox"
                      value="MENİNGOMİYELOSEL"
                      v-model="yatis.tanilar"
                    />
                    <span>Meningomiyelosel</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="tani31">
                    <input
                      id="tani31"
                      class="modern"
                      type="checkbox"
                      value="ASFİKSİ"
                      v-model="yatis.tanilar"
                    />
                    <span>Asfiksi</span>
                  </label>
                  <label for="tani32">
                    <input
                      id="tani32"
                      class="modern"
                      type="checkbox"
                      value="KONVÜLZYON"
                      v-model="yatis.tanilar"
                    />
                    <span>Konvülzyon</span>
                  </label>
                </div>
              </div>
            </div>
            <div v-show="activeTab == 4">
              <h4>Hastanın Muayenesi</h4>
              <div class="labeledit">
                <textarea
                  spellcheck="false"
                  class="c-input"
                  placeholder="Muayene"
                  rows="12"
                  v-model="sonuc.muayene"
                ></textarea>
              </div>
              <h4>Yatış Sırasında Yapılanlar</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="katater1">
                    <input
                      id="katater1"
                      class="modern"
                      type="checkbox"
                      value="DAMARYOLU"
                      v-model="yatis.katater"
                    />
                    <span>Damaryolu</span>
                  </label>
                  <label for="katater2">
                    <input
                      id="katater2"
                      class="modern"
                      type="checkbox"
                      value="GÖBEK VEN KATATERİ"
                      v-model="yatis.katater"
                    />
                    <span>Göbek Ven Katateri</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="surf1">
                    <input
                      id="surf1"
                      class="modern"
                      type="checkbox"
                      value="CUROSURF"
                      v-model="yatis.surfaktan"
                    />
                    <span>Curosurf</span>
                  </label>
                  <label for="surf2">
                    <input
                      id="surf2"
                      class="modern"
                      type="checkbox"
                      value="SURVANTA"
                      v-model="yatis.surfaktan"
                    />
                    <span>Survanta</span>
                  </label>
                </div>
              </div>
              <h4>Alınan Tetkikler ve Tedaviler</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="tetkik1">
                    <input
                      id="tetkik1"
                      class="modern"
                      type="checkbox"
                      value="HEMOGRAM"
                      v-model="yatis.tetkik"
                    />
                    <span>Hemogram</span>
                  </label>
                  <label for="tetkik2">
                    <input
                      id="tetkik2"
                      class="modern"
                      type="checkbox"
                      value="BİYOKİMYA"
                      v-model="yatis.tetkik"
                    />
                    <span>Biyokimya</span>
                  </label>
                  <label for="tetkik3">
                    <input
                      id="tetkik3"
                      class="modern"
                      type="checkbox"
                      value="CRP"
                      v-model="yatis.tetkik"
                    />
                    <span>CRP</span>
                  </label>
                  <label for="tetkik4">
                    <input
                      id="tetkik4"
                      class="modern"
                      type="checkbox"
                      value="KAN GAZI"
                      v-model="yatis.tetkik"
                    />
                    <span>Kan Gazı</span>
                  </label>
                  <label for="tetkik5">
                    <input
                      id="tetkik5"
                      class="modern"
                      type="checkbox"
                      value="KAN KÜLTÜRÜ"
                      v-model="yatis.tetkik"
                    />
                    <span>Kan Kültürü</span>
                  </label>
                  <label for="tetkik6">
                    <input
                      id="tetkik6"
                      class="modern"
                      type="checkbox"
                      value="İDRAR KÜLTÜRÜ"
                      v-model="yatis.tetkik"
                    />
                    <span>İdrar Kültürü</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="ilac1">
                    <input
                      id="ilac1"
                      class="modern"
                      type="checkbox"
                      value="AMPİSİLİN"
                      v-model="yatis.ilac"
                    />
                    <span>Ampisilin</span>
                  </label>
                  <label for="ilac2">
                    <input
                      id="ilac2"
                      class="modern"
                      type="checkbox"
                      value="GENTAMİSİN"
                      v-model="yatis.ilac"
                    />
                    <span>Gentamisin</span>
                  </label>
                  <label for="ilac3">
                    <input
                      id="ilac3"
                      class="modern"
                      type="checkbox"
                      value="SEFOTAKSİM"
                      v-model="yatis.ilac"
                    />
                    <span>Sefotaksim</span>
                  </label>
                  <label for="ilac4">
                    <input
                      id="ilac4"
                      class="modern"
                      type="checkbox"
                      value="FLUKONAZOL"
                      v-model="yatis.ilac"
                    />
                    <span>Flukonazol</span>
                  </label>
                </div>
              </div>
              <br />
              <div class="labeledit">
                <label for="p-total">Total (cc/kg)</label>
                <div class="multi-input">
                  <input
                    type="number"
                    placeholder="Mayi miktarı"
                    id="p-total"
                    v-model="yatis.total"
                  />
                  <div class="space"></div>
                  <select id="p-mayi" v-model="yatis.totalmayi">
                    <option value="%10 DEXTROZ">
                      %10 Dekstroz
                    </option>
                    <option value="%5 DEXTROZ">
                      %5 Dekstroz
                    </option>
                    <option value="1/5 MAYİ">
                      1/5 Mayi
                    </option>
                    <option value="1/3 MAYİ">
                      1/3 Mayi
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div v-show="activeTab == 5">
              <h4>Yatış Notu</h4>
              <br />
              <p>
                Hastanın hikayesindeki eksik ve yanlış bilgiler olması
                ihtimaline karşı kontrol etmelisiniz.
              </p>
              <br />
              <div class="labeledit">
                <textarea
                  spellcheck="false"
                  class="c-input"
                  placeholder="Yatış Notu"
                  rows="10"
                  v-model="sonuc.not"
                ></textarea>
              </div>
              <br />
              <div class="labeledit">
                <textarea
                  spellcheck="false"
                  placeholder="Yatış Sonrası Yapılan Müdahaleler"
                  rows="6"
                  class="c-input"
                  v-model="mudahale"
                ></textarea>
              </div>
              <br />
              <p>
                SNAP Skorlamasını şimdi girmek zorunlu değil. Daha sonra "Yatış
                Notu" bölümünden girebilirsiniz
              </p>
              <br />
              <div class="labeledit">
                <label for="p-snap">SNAP Skorlama</label>
                <div class="multi-input">
                  <input
                    type="number"
                    placeholder="SNAP II"
                    class="c-input"
                    id="p-snap"
                    v-model="yatis.snap"
                  />
                  <div class="space"></div>
                  <input
                    type="number"
                    class="c-input"
                    placeholder="SNAP-PE II"
                    id="p-snappe"
                    v-model="yatis.snappe"
                  />
                </div>
              </div>
            </div>
            <div class="wizard-buttons">
              <button
                class="btn btn-blue fr"
                v-show="next"
                @click="navigate(1)"
              >
                <i class="fa fa fa-angle-right"></i>
                Devam Et
              </button>
              <button
                class="btn btn-blue fl"
                v-show="prev"
                @click="navigate(-1)"
              >
                <i class="fa fa fa-angle-left"></i>
                Geri
              </button>
              <button
                class="btn btn-green fr"
                v-show="activeTab == 5"
                @click="yatir()"
              >
                <i class="fa fa fa-check"></i>
                Yatışı Tamamla
              </button>
              <button
                class="btn btn-indigo fr"
                v-show="activeTab == 5"
                @click="print()"
              >
                <i class="fa fa fa-print"></i>
                Yazdır
              </button>
            </div>
          </form>
        </div>
      </div>
      <div id="printArea" class="p-not">
        <p>
          <center>
            <b>YATIŞ NOTU</b>
          </center>
        </p>
        <p style="text-align: right">
          <b>{{ new Date() | moment("DD.MM.YYYY") }}</b>
        </p>
        <p>
          <b>{{ yatis.name | toUpperCase }}</b>
        </p>
        <p style="word-spacing: pre">{{ sonuc.not | toUpperCase }}</p>
        <p style="word-spacing: pre">
          {{ part3 | toUpperCase }}
          {{ part4 | toUpperCase }}
          <br />
          <br />
          {{ skorlama | toUpperCase }}
        </p>
        <p style="text-align: right">
          <b>{{ yatirandr.id > 0 ? "Dr." + yatirandr.name : "" }}</b>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "NewYD",
  data() {
    return {
      activeTab: 1,
      tabs: {
        1: "Hasta Bilgileri",
        2: "Hasta Öyküsü",
        3: "Semptom ve Tanılar",
        4: "Hastanın Muayenesi",
        5: "Yatış Notu",
      },
      yatis: {
        dosya: "",
        name: "",
        ytarti: "",
        sex: "-1",
        hepb: "1",
        kvit: "1",
        anneyas: "",
        annekan: "",
        kan: "",
        coombs: "",
        birth: "",
        gebelik: "",
        yasayan: "",
        dtarti: "",
        dhafta: "",
        kanama: "?",
        dgun: "",
        sekil: "",
        apgar: "",
        res: "4",
        elisa: "",
        anneoyku: [],
        steroid: "",
        bulgu: [],
        tanilar: [],
        katater: ["DAMARYOLU"],
        surfaktan: [],
        tetkik: ["HEMOGRAM", "KAN GAZI", "KAN KÜLTÜRÜ"],
        ilac: [],
        total: "",
        totalmayi: "%10 DEXTROZ",
        snap: "",
        snappe: "",
        boy: "",
        basc: "",
        dr: null,
        durum: "",
        khd: 0,
      },
      sonuc: {
        muayene: "",
        not: "",
        taburcu: "",
      },
      mudahale: "",
    };
  },
  watch: {
    yatis: {
      deep: true,
      immediate: true,
      handler: function() {
        this.mudahale =
          "HASTA MONİTORİZE EDİLDİ. HASTAYA " +
          this.yatis.katater +
          " AÇILDI. HASTADAN " +
          this.yatis.tetkik +
          " GÖNDERİLDİ. " +
          (this.yatis.ilac.length > 0
            ? "HASTAYA " + this.yatis.ilac + " BAŞLANDI."
            : "") +
          "HASTAYA " +
          this.yatis.total +
          " CC/KG'DAN " +
          this.yatis.totalmayi +
          " BAŞLANDI. PA AC GRAFİSİ ÇEKİLDİ." +
          (this.yatis.surfaktan.length > 0
            ? "PA AC GRAFİSİ RDS İLE UYUMLU GÖRÜLEN HASTAYA UYGUN DOZDA " +
              this.yatis.surfaktan +
              " VERİLDİ."
            : "");

        var cilt = "";
        if (this.isTani("YD SARILIĞI")) {
          cilt += "İKTERİK ";
        }
        if (this.isTani("DEHİDRATASYON")) {
          cilt += "DEHİDRATE ";
        }

        var dispne = "İNLEME (+) ÇEKİLME (+) TAKİPNE (+)";
        var takipne = "İNLEME (-) ÇEKİLME (-) TAKİPNE (+)";
        var solunum = "İNLEME (-) ÇEKİLME (-) TAKİPNE (-)";
        if (this.isTani("TTN") || this.isTani("PULMONER HİPERTANSİYON")) {
          solunum = takipne;
        }
        if (
          this.isTani("KONJENİTAL PNÖMONİ") ||
          this.isTani("RDS") ||
          this.isTani("DİYAFRAGMA HERNİSİ")
        ) {
          solunum = dispne;
        }

        var batin = "RAHAT";
        if (this.isTani("İLEUS") || this.isTani("İNTRAABDOMİNAL KİTLE")) {
          batin = "DİSTANDÜ";
        }
        if (this.isTani("OMFALOSEL")) {
          batin = "OMFALOSEL İLE UYUMLU KESE MEVCUT";
        }
        if (this.isTani("GASTROŞİZİS")) {
          batin = "GASTROŞİZİS (+)";
        }

        var emme = "+";
        var refleks = "YAKALAMA +/+  MORRO +";
        if (
          this.isTani("YD EKSİK BESLENMESİ") ||
          this.isTani("ERKEN NEONATAL SEPSİS") ||
          this.isTani("GEÇ NEONATAL SEPSİS")
        ) {
          emme = "ZAYIF";
        }
        if (this.isTani("ASFİKSİ")) {
          refleks = "YAKALAMA ZAYIF, MORRO ZAYIF";
        }

        var noro = "";
        if (this.isTani("MENİNGOSEL") || this.isTani("MENİNGOMİYELOSEL")) {
          noro = "NÖRAL TÜP DEFEKTİ (+)";
        }

        var r = [];
        r.push("GENEL DURUMU ORTA");
        r.push("CİLT : " + (cilt == "" ? "DOĞAL " : cilt) + "GÖRÜNÜMDE");
        r.push(
          "BAŞ-BOYUN : ÖN FONTANEL VE ARKA FONTANEL AÇIK, YARIK DAMAK " +
            (this.isTani("YARIK DAMAK") ? "VAR" : "YOK") +
            " , YARIK DUDAK " +
            (this.isTani("YARIK DUDAK") ? "VAR" : "YOK") +
            ", KOANAL ATREZİ " +
            (this.isTani("KOANAL ATREZİ") ? "VAR" : "YOK")
        );
        r.push("SOLUNUM SİSTEMİ : " + solunum + " HIHSEK");
        r.push(
          "KVS : S1+ S2 + EK SES YOK, ÜFÜRÜM " +
            (this.isTani("KONJENİTAL KALP HASTALIĞI") ? "MEVCUT" : "DUYULMADI")
        );
        r.push(
          "BATIN : " +
            batin +
            ", GÖBEK 2 ARTER 1 VEN GÖRÜLDÜ. " +
            "ANAL ATREZİ " +
            (this.isTani("ANAL ATREZİ") ? "VAR" : "YOK")
        );
        r.push("LENFATİK : DOĞAL");
        var c;
        switch (this.yatis.sex) {
          case "1":
            c =
              "HARİCEN ERKEK. TESTİSLER SKROTUMDA PALPE " +
              (this.isTani("İNMEMİŞ TESTİS") ? "EDİLEMEDİ" : "EDİLDİ");
            break;
          case "2":
            c = "HARİCEN KIZ. LABİAL YAPIŞIKLIK GÖRÜLMEDİ";
            break;
          case "-1":
            c = "";
            break;
        }
        r.push("GENİTOÜRİNER : " + c);
        r.push(
          "EKSTREMİTELER : DOĞAL, AKTİF, " +
            (this.isTani("ASFİKSİ") ? "ZAYIF HAREKETLİ" : "HAREKETLİ")
        );
        r.push(
          "NÖROLOJİK : EMME REFLEKSİ " + emme + " " + refleks + " " + noro
        );
        this.sonuc.muayene = r.join("\n");
        this.sonuc.not = this.part1 + this.part2;
        this.sonuc.taburcu =
          `1.Anne sütü ile beslenecek.
2.__.__.2021 de Çocuk Polikliniğine randevu alınarak gelinecek. (Çıkış kilo ... gr, Çıkış boy ` +
          this.yatis.boy +
          ` cm, Çıkış bç ` +
          this.yatis.basc +
          ` cm)
Kilo takibi boy baş çevresi takibi yapılacak.
3.Aile hekimliğinde aşılarını yaptıracak. İlk doz Hepatit B aşısı ` +
          (this.yatis.hepb == "2"
            ? this.$moment(this.yatis.birth).format("DD.MM.YYYY")
            : "__.__.2021") +
          ` de yapıldı . __.__.2021 de Topuk Kanı alındı.Aileye aşı kartı verildi.
4. De-vit 3 damla 1X3 damla 2 yaşına kadar kullanacak.
5. İşitme testi (BERA) yapılacak
6. 1 aylık olunca Kalça USG çekilecek`;
      },
    },
  },
  computed: {
    head() {
      return this.tabs[this.activeTab];
    },
    part1() {
      return (
        (this.yatis.anneyas > 0
          ? this.yatis.anneyas + " YAŞINDAKİ" + this.anne + "ANNEDEN "
          : this.anne + " ANNENİN ") +
        this.gh +
        " GH OLAN " +
        (this.yatis.gebelik && this.yatis.yasayan != ""
          ? this.yatis.gebelik +
            ".GEBELİĞİNDEN " +
            this.yatis.yasayan +
            ".YAŞAYANI OLARAK "
          : "GEBELİĞİNDEN ") +
        (this.yatis.sekil != "" ? this.yatis.sekil + " İLE " : "") +
        this.$moment(this.yatis.birth).format("DD.MM.YYYY HH:mm") +
        " TARİHİNDE HARİCEN " +
        this.cinsiyet(this.yatis.sex) +
        " DOĞDU." +
        "\n\n"
      );
    },
    part2() {
      var r;
      switch (this.yatis.res) {
        case "1":
          r = "ANNE YANINDA TAKİP EDİLEN HASTA";
          break;
        case "2":
          r = "HASTANEMİZE BAŞVURAN HASTA";
          break;
        case "3":
          r = "DIŞ MERKEZDEN TARAFIMIZA SEVK EDİLEN HASTA";
          break;
        case "4":
          r =
            "DOĞAR DOĞMAZ AĞLADI. RADİANT ISITICI ALTINDA AĞIZ BURUN ASPİRASYONU YAPILDI. GÖBEK KORDONU STERİL ŞARTLARDA KLEMPLENDİ VE KESİLDİ. KTA > 100 ATIM/DK VE SPONTAN SOLUNUMU OLDUĞU GÖZLENDİ.  HASTA";
          break;
        case "5":
          r =
            "DOĞAR DOĞMAZ ZAYIF AĞLADI. RADİANT ISITICI ALTINDA AĞIZ BURUN ASPİRASYONU YAPILDI. GÖBEK KORDONU STERİL ŞARTLARDA KLEMPLENDİ VE KESİLDİ. KTA < 100 ATIM/DK GÖRÜLEN HASTAYA 30 SN ETKİN PBV UYGULANDI. ETKİN PBV SONRASI KTA > 100 ATIM/DK VE SPONTAN SOLUNUMU OLDUĞU GÖRÜLDÜ. HASTA";
          break;
        case "6":
          r =
            "DOĞAR DOĞMAZ AĞLAMADI. RADİANT ISITICI ALTINDA AĞIZ BURUN ASPİRASYONU YAPILDI. GÖBEK KORDONU STERİL ŞARTLARDA KLEMPLENDİ VE KESİLDİ. KTA < 100 ATIM/DK GÖRÜLEN HASTAYA 30 SN ETKİN PBV UYGULANDI. ETKİN PBV SONRASI KTA < 100 ATIM/DK GÖRÜLEN HASTA ENTÜBE EDİLDİ. ENTÜBASYON SONRASI KTA > 100 ATIM/DK OLAN HASTA YDYBÜ'NE GETİRİLDİ. HASTA";
          break;
      }

      return (
        r + " " + this.yatis.tanilar + " ÖNTANILARI İLE YDYBÜ YATIŞI YAPILDI."
      );
    },
    part3() {
      var k = Array();
      if (this.yatis.annekan != "") {
        k.push("ANNE KAN GRUBU : " + this.yatis.annekan);
      }
      if (this.yatis.kan != "") {
        k.push("BEBEK KAN GRUBU : " + this.yatis.kan);
      }
      if (this.yatis.coombs != "") {
        k.push("BEBEK D.COOMBS : " + this.yatis.coombs);
      }
      var t = Array();
      t.push("DOĞUM TARTISI :" + this.yatis.dtarti + " GR");
      t.push(
        "YATIŞ TARTISI : " +
          this.yatis.ytarti +
          " GR" +
          (this.yatis.dtarti > this.yatis.ytarti
            ? " (FARK %" +
              Math.ceil(
                ((this.yatis.dtarti - this.yatis.ytarti) / this.yatis.dtarti) *
                  1000
              ) /
                10 +
              ")"
            : "")
      );

      return (
        t +
        "." +
        this.apgarhepatitkvit +
        this.steroid +
        "\n\n" +
        (k.length > 0 ? k + "\n\n" : "")
      );
    },
    part4() {
      return this.mudahale;
    },
    skorlama() {
      var r;

      var s = this.yatis.snap;
      var s2 = this.yatis.snappe;
      var o1, o2, o3, o4, o5, o6;
      if (s != "" && s2 != "") {
        switch (true) {
          case s2 >= 0 && s2 <= 9:
            o1 = 0.3;
            o2 = 0.3;
            o3 = 0.6;
            o4 = 0.5;
            o5 = 0.3;
            o6 = 0.3;
            break;
          case s2 >= 10 && s2 <= 19:
            o1 = 1.6;
            o2 = 1.6;
            o3 = 2.7;
            o4 = 2.2;
            o5 = 1.1;
            o6 = 1.3;
            break;
          case s2 >= 20 && s2 <= 29:
            o1 = 3.8;
            o2 = 3.6;
            o3 = 5.2;
            o4 = 4.9;
            o5 = 2.9;
            o6 = 2.8;
            break;
          case s2 >= 30 && s2 <= 39:
            o1 = 7.4;
            o2 = 8.0;
            o3 = 9.5;
            o4 = 9.3;
            o5 = 5.2;
            o6 = 6.5;
            break;
          case s2 >= 40 && s2 <= 49:
            o1 = 15.7;
            o2 = 14.7;
            o3 = 15.9;
            o4 = 15.7;
            o5 = 15.4;
            o6 = 13.0;
            break;
          case s2 >= 50 && s2 <= 59:
            o1 = 22.1;
            o2 = 21.4;
            o3 = 22.6;
            o4 = 22.6;
            o5 = 20.9;
            o6 = 19.0;
            break;
          case s2 >= 60 && s2 <= 69:
            o1 = 32.6;
            o2 = 32.3;
            o3 = 32.7;
            o4 = 32.3;
            o5 = 32.0;
            o6 = 32.0;
            break;
          case s2 >= 70 && s2 <= 79:
            o1 = 38.7;
            o2 = 44.4;
            o3 = 38.0;
            o4 = 43.8;
            o5 = 42.9;
            o6 = 47.6;
            break;
          case s2 >= 80:
            o1 = 66.7;
            o2 = 63.8;
            o3 = 66.7;
            o4 = 64.4;
            o5 = 66.7;
            o6 = 55.6;
            break;
          default:
            o1 = 0.3;
            o2 = 0.3;
            o3 = 0.6;
            o4 = 0.5;
            o5 = 0.3;
            o6 = 0.3;
            break;
        }
        r =
          "HASTANIN SNAP 2 SKORU " +
          s +
          ", SNAP-PE 2 SKORU " +
          s2 +
          " OLARAK HESAPLANDI.\n\nSNAP-PE 2 SKORUNA GÖRE TÜM DOĞUM AĞIRLIKLARI İÇİN GÖZLENEN ÖLÜM ORANI %" +
          o1 +
          ", BEKLENEN ÖLÜM ORANI %" +
          o2 +
          " OLARAK HESAPLANDI.\nSNAP-PE 2 SKORUNA GÖRE KENDİ DOĞUM AĞIRLIKLARI İÇİN GÖZLENEN ÖLÜM ORANI %" +
          (this.yatis.dtarti < 1500 ? o3 : o5) +
          " BEKLENEN ÖLÜM ORANI % " +
          (this.yatis.dtarti < 1500 ? o4 : o6) +
          " OLARAK HESAPLANDI.";

        return r;
      } else {
        return "";
      }
    },
    yatis_notu() {
      return this.part3 + this.part4;
    },
    ozgecmis() {
      var prenatal, steroid, natal, postnatal;
      if (this.yatis.anneoyku == "") {
        prenatal =
          "PRENATAL: ENFEKSİYON (-) DM (-)  HT (-)  İLAÇ KULLANIMI (-)";
      } else {
        prenatal = "PRENATAL: " + this.yatis.anneoyku;
      }
      if (this.yatis.steroid == "") {
        steroid =
          "ANTEPARTUM KANAMA (" +
          this.yatis.kanama +
          ") ANTENATAL STEROİD : (?)";
      } else {
        steroid =
          "ANTEPARTUM KANAMA (" +
          this.yatis.kanama +
          ") ANTENATAL STEROİD : " +
          this.yatis.steroid;
      }
      if (this.yatis.sekil == "") {
        natal = "NATAL: (BİLİNMİYOR)";
      } else {
        natal = "NATAL: " + this.yatis.sekil;
      }

      if (this.yatis.apgar == "") {
        postnatal = "POSTNATAL: (APGAR BİLİNMİYOR)";
      } else {
        postnatal = "POSTNATAL: APGAR " + this.yatis.apgar;
      }
      return prenatal + "\n" + steroid + "\n" + natal + "\n" + postnatal;
    },
    soygecmis() {
      var anne, baba, akrabalik, gebelik;
      anne = "ANNE " + this.yatis.anneyas + " YAŞINDA";
      baba = "BABA .... YAŞINDA";
      akrabalik = "AKRABALIK: ";
      gebelik =
        "G:" +
        this.yatis.gebelik +
        " A: P: Y:" +
        this.yatis.yasayan +
        "  KÜRTAJ VE DÜŞÜK : ";
      return anne + "\n" + baba + "\n" + akrabalik + "\n" + gebelik;
    },
    gh() {
      return (
        this.yatis.dhafta +
        "w" +
        (this.yatis.dgun > 0 ? "+" + this.yatis.dgun + "d" : "")
      );
    },
    steroid() {
      if (this.yatis.steroid != "") {
        return " ANNEYE " + this.yatis.steroid + ".";
      } else {
        return "";
      }
    },
    anne() {
      var r = Array();
      r = JSON.parse(JSON.stringify(this.yatis.anneoyku));
      if (this.yatis.elisa != "") {
        r.push(this.yatis.elisa);
      }
      if (r.length > 0) {
        return " " + r + " OLAN ";
      } else {
        return " ";
      }
    },
    apgarhepatitkvit() {
      var a, h, k;
      a = this.yatis.apgar != "" ? " APGAR " + this.yatis.apgar + "." : "";
      switch (this.yatis.hepb) {
        case "2":
          h = "DOĞUMUNDA HEPATİT B AŞISI YAPILDI.";
          break;
        case "3":
          if (this.yatis.dtarti < 2000) {
            h =
              "D.TARTISI < 2000 GR OLDUĞU İÇİN DOĞUMUNDA HEPATİT B AŞISI YAPILMADI.";
          } else {
            h = "DOĞUMUNDA HEPATİT B AŞISI YAPILMADI.";
          }

          break;
        default:
          h = "";
          break;
      }
      switch (this.yatis.kvit) {
        case "2":
          k = "DOĞUMUNDA K VİT YAPILDI.";
          break;
        case "3":
          k = "DOĞUMUNDA K VİT YAPILAMADI.";
          break;
        default:
          k = "";
          break;
      }

      return a + " " + h + " " + k;
    },
    yatirandr: {
      get() {
        var r;
        if (this.yatis.dr === null) {
          if (this.user.level == 0) {
            r = { id: 0 };
          } else {
            r = { id: this.user.id, name: this.user.name };
          }
        } else {
          r = this.yatis.dr;
        }
        return r;
      },
      set(val) {
        this.yatis.dr = val;
      },
    },
    user() {
      return this.$store.getters.getUser;
    },
    doctors() {
      return this.$store.getters.getDoctors;
    },
    activedoctors() {
      return this.$store.getters.getActiveDoctors;
    },
    prev() {
      return this.activeTab > 1 ? true : false;
    },
    next() {
      return this.activeTab < 5 ? true : false;
    },
  },
  methods: {
    isTani(data) {
      if (this.yatis.tanilar.includes(data)) {
        return true;
      } else {
        return false;
      }
    },
    setDogumData(data) {
      if (Object.keys(data).length > 0) {
        this.yatis.durum = "KHD";
        this.yatis.khd = data.id;
        this.yatis.name = data.bebek;
        this.yatis.birth = data.birthv2;
        this.yatis.sex = data.sex;
        this.yatis.dhafta = data.week;
        this.yatis.dgun = data.day;
        this.yatis.dtarti = data.tarti;
        this.yatis.apgar = data.apgar;
        if (data.sekil == "C/S") {
          this.yatis.sekil = "SPİNAL ANESTEZİ ALTINDA C/S";
        }
        if (data.sekil == "NVD") {
          this.yatis.sekil = "NVD";
        }
        if (data.tarti > 2000) {
          this.yatis.hepb = "2";
        } else {
          this.yatis.hepb = "3";
        }
        this.yatis.kvit = "2";
        if (data.elisa == "(-)") {
          this.yatis.elisa = "ELISA (-)";
        } else {
          this.yatis.elisa = data.elisa;
        }
        this.yatis.annekan = data.annekan;
        this.yatis.kan = data.kan;
        this.yatis.coombs = data.coombs;
      }
    },
    cinsiyet(s) {
      var r;
      switch (s) {
        case "0":
          r = "";
          break;
        case "1":
          r = "ERKEK";
          break;
        case "2":
          r = "KIZ";
          break;
        default:
          r = "";
          break;
      }
      return r;
    },
    validateEmpty(list) {
      let r = true;
      list.forEach((item) => {
        if (item == "") {
          r = false;
        }
      });
      return r;
    },
    validateDate(list) {
      let r = true;
      list.forEach((item) => {
        if (!this.$moment(item).isValid()) {
          r = false;
        }
      });
      return r;
    },
    navigate(step) {
      if (this.activeTab + step != 6 || this.activeTab + step != 0) {
        if (
          !this.validateEmpty([
            this.yatis.name,
            this.yatis.dtarti,
            this.yatis.ytarti,
            this.yatis.dhafta,
          ]) ||
          !this.validateDate([this.yatis.birth]) ||
          this.yatis.sex == "-1"
        ) {
          this.$snotify.warning(
            "Zorunlu alanları doldurmadan devam edemezsiniz"
          );
        } else {
          this.activeTab = this.activeTab + step;
        }
      }
    },
    yatir() {
      let kultur;

      if (this.yatis.tetkik.includes("KAN KÜLTÜRÜ")) {
        kultur = this.$moment(new Date()).format("DD.MM") + " KAN KX :" + "\n";
      }
      if (this.yatis.tetkik.includes("İDRAR KÜLTÜRÜ")) {
        kultur +=
          this.$moment(new Date()).format("DD.MM") + " İDRAR KX :" + "\n";
      }

      this.$http({
        method: "post",
        url: "api/yenidogan/add-patient.php",
        data: qs.stringify({
          durum: this.yatis.durum,
          khd: this.yatis.khd,
          dosya: this.yatis.dosya,
          name: this.yatis.name,
          sex: this.yatis.sex,
          birth: this.yatis.birth,
          dtarti: this.yatis.dtarti,
          ytarti: this.yatis.ytarti,
          dhafta: this.yatis.dhafta,
          dgun: this.yatis.dgun,
          sekil: this.yatis.sekil,
          apgar: this.yatis.apgar,
          boy: this.yatis.boy,
          basc: this.yatis.basc,
          annekan: this.yatis.annekan,
          kan: this.yatis.kan,
          coombs: this.yatis.coombs,
          tanilar: this.yatis.tanilar.join(),
          total:
            "TOTAL " +
            this.yatis.total +
            " CC/KG " +
            this.yatis.totalmayi +
            "\nBESLENME :",
          ozgecmis: this.ozgecmis,
          soygecmis: this.soygecmis,

          oyku: this.sonuc.not,
          muayene: this.sonuc.muayene,
          taburcu: this.sonuc.taburcu,
          snap: this.skorlama,
          plan: kultur,
          plan2: "",
          tedaviler: this.yatis.ilac,
          ynot: this.yatis_notu,
          dr: this.yatirandr.id,
        }),
      })
        .then((r) => {
          this.$snotify.success(
            "Yatış başarıyla yapıldı. Yenidoğan sayfasına yönlendiriliyorsunuz."
          );

          this.$store.dispatch("fillPatients");
          const userId = r.data.id;
          this.$socket.client.emit(
            "yatis",
            this.yatis.name,
            this.yatis.tanilar
          );
          this.$router.push({
            path: `/patients/yogunbakim/${userId}`,
          });
        })
        .catch((e) =>
          this.$snotify.error(
            "Yatış işlemi hata oluştuğu için yapılamadı : " + e
          )
        );
    },
    print() {
      const options = {
        name: "_blank",
        specs: ["height=800", "height=800", "titlebar=yes", "scrollbars=yes"],
        styles: ["https://pediatrim.net/print/yatis.css"],
      };
      this.$htmlToPaper("printArea", options);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => vm.setDogumData(to.params));
  },
};
</script>

<style lang="scss"></style>
